import dataProcessLia from './dataProcessLia'

const pages = { dataProcessLia }

export default pages
